var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalesDataInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 20H0V22H22V20Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13H2V19H4V13Z",
    fill: "#242424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H6V19H8V16Z",
    fill: "#242424"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H10V19H12V4Z",
    fill: "#242424"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H14V19H16V8Z",
    fill: "#242424"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H18V19H20V0Z",
    fill: "#242424"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesDataInactive);
export default __webpack_public_path__ + "static/media/sales-data-inactive.e71a7f3a4b35e35e9dc6c16d8c3e2792.svg";
export { ForwardRef as ReactComponent };